const chatRoom = ['general', 'travel', 'music'];

export { chatRoom };
